'use strict';

module.exports = exports = require('./ArrayUtils');

exports.getEquallySpacedData = require('./getEquallySpaced').getEquallySpacedData;
exports.SNV = require('./snv').SNV;



// WEBPACK FOOTER //
// ./node_modules/ml-array-utils/src/index.js